import { Component, inject } from '@angular/core';
import { SidebarStateService } from '../../services/sidebar.service';
import { TopbarSlotService } from '../../services/topbar-slot.service';

@Component({
    selector: 'app-top-navigation',
    templateUrl: './top-navigation.component.html',
    standalone: false,
})
export class TopNavigationComponent {
    private sidebarStateService = inject(SidebarStateService);
    public moduleData$ = this.sidebarStateService.moduleData$;
    /** Control contributed by the active lazy module (e.g. market-reports usage meter). */
    public topbarSlot = inject(TopbarSlotService).content;
    public isExpanded = this.sidebarStateService.isExpanded;
}
